module.exports = __webpack_public_path__ + "static/media/yes_bank.7e6cb234.png";